import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockChip from '../components/GuideMockChip';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideUserSearch: React.FC = () => {
  return (
    <GuidePageLayout
      title="ユーザーを検索する"
      description="条件を指定してユーザーを検索し、一覧を確認します。"
      breadcrumbs={[{ label: 'ユーザー管理', path: '/guide/user/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: 'ユーザー管理画面を開く' },
            {
              label: '検索条件を入力する（全て任意、未入力で全件検索）',
              description: '検索パネルで条件チップを追加して絞り込みます。',
              content: (
                <GuideMockContainer label="検索条件チップ">
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    <GuideMockChip label="ユーザーID: admin" color="info" />
                    <GuideMockChip label="ユーザー名: 田中" color="info" />
                    <GuideMockChip label="メールアドレス: tanaka" color="info" />
                  </Stack>
                </GuideMockContainer>
              ),
            },
            { label: '「検索」ボタンを押下する' },
            { label: '検索結果が一覧パネルに表示される' },
          ]}
        />
      </GuideSection>

      <GuideSection title="検索条件">
        <GuideTable
          headers={['項目名', '形式', '検索方法', '備考']}
          rows={[
            ['ユーザーID', 'テキスト', '前方一致', ''],
            ['ユーザー名', 'テキスト', '前方一致', ''],
            ['メールアドレス', 'テキスト', '前方一致', ''],
          ]}
        />
      </GuideSection>

      <GuideSection title="検索結果一覧の表示">
        <GuideTable
          headers={['表示項目', '位置', '説明']}
          rows={[
            ['ユーザー名', 'メイン（左）', 'ユーザーの表示名'],
            ['ロールChip', 'メイン（右）', 'ユーザーに付与されたロールを表示（複数表示あり）'],
            ['メールアドレス', 'サブテキスト', 'ユーザーのメールアドレス'],
          ]}
        />
        <GuideMockContainer label="リスト項目の表示例">
          <Stack spacing={1}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="body2" fontWeight={500}>
                田中 太郎
              </Typography>
              <Stack direction="row" spacing={0.5}>
                <GuideMockChip label="管理者" color="error" size="small" />
                <GuideMockChip label="課長" color="success" size="small" />
              </Stack>
            </Stack>
            <Typography variant="caption" color="text.secondary">
              tanaka@example.com
            </Typography>
          </Stack>
        </GuideMockContainer>
        <GuideTable
          headers={['Chip', '意味', '表示条件', '色']}
          rows={[
            ['管理者', 'ADMIN ロール', 'ユーザーがADMINロールを持つ場合', '赤'],
            ['一般', 'GENERAL ロール', 'ユーザーがGENERALロールを持つ場合', '青'],
            ['課長', 'MANAGER ロール', 'ユーザーがMANAGERロールを持つ場合', '緑'],
            ['管理部門', 'BACK_OFFICE ロール', 'ユーザーがBACK_OFFICEロールを持つ場合', '紫'],
            ['開発者', 'DEVELOPER ロール', 'ユーザーがDEVELOPERロールを持つ場合', 'オレンジ'],
          ]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>表示件数には上限があります。条件を絞って検索してください。</GuideInfoBox>
          <GuideInfoBox>ユーザー名の昇順でソートされます。</GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideUserSearch;
